import { useContext } from "react";
import USPositionContext from "../contexts/USPositionProvider";

const useUSPosition = () => {
  return useContext(USPositionContext);
};

export default useUSPosition;
